module.exports = __webpack_public_path__ + "img/3.af3d996c.jpg";